import ElectronicCommunicationsAgreementContent from "../ElectronicCommunicationsAgreementContent";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React from "react";
import styles from "./ECommPage.module.css";
import usePageView from "../../lib/usePageView";
import {Container, Row, Column} from "../grid";

export default function ElectronicCommunicationsAgreementFullPage() {
    usePageView(document.title);
    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.textRow}>
                    <Column>
                        <ElectronicCommunicationsAgreementContent />
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
